import { Box, Link as MuiLink, Typography } from '@mui/material';

import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import styles from './SourceBanner.styles';

const useStyles = makeStyles()(styles);

/*
 * Compact banner shown above the chat input on Privacy Team threads that
 * originated from an AI conversation. Opens the source AI chat in-place so the
 * user can re-read the context that prompted them to escalate.
 */
const SourceBanner = ({ aiConversationId, onOpenConversation }) => {
    const { classes } = useStyles();
    return (
        <Box className={classes.root}>
            <AutoAwesomeOutlinedIcon className={classes.icon} />
            <Typography variant="caption" className={classes.text}>
                <Locale path="aiAssistant.banners.openedFromAi.message" />
            </Typography>
            <MuiLink
                component="button"
                type="button"
                variant="caption"
                underline="always"
                onClick={() => onOpenConversation?.(aiConversationId)}
            >
                <Locale path="aiAssistant.banners.openedFromAi.link" />
            </MuiLink>
        </Box>
    );
};

SourceBanner.propTypes = {
    aiConversationId: PropTypes.string.isRequired,
    onOpenConversation: PropTypes.func,
};

export default SourceBanner;
